import CnCustomer from "../images/cn/customer2.png"




import { UserLogoMapType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapType = {
    cn: CnCustomer,



};
